import { Component, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { IUploadedFile } from '@app-root-interfaces';
import { uploadSelectors, appReducer, uploadActions, documentActions } from '@app-root-store';
import { Store, select } from '@ngrx/store';
import { EUploadState } from '@app-root-enums';

@Component({
    selector: 'app-files-popup',
    templateUrl: './files-popup.component.html',
    styleUrls: ['./files-popup.component.scss'],
    standalone: false
})
export class FilesPopupComponent {
    private store$ = inject<Store<appReducer.AppState>>(Store);

    public uploadedFiles$: Observable<IUploadedFile[]> = this.store$.pipe(select(uploadSelectors.selectUploadFiles));

    public readyFiles$: Observable<IUploadedFile[]> = this.store$.pipe(
        select(uploadSelectors.selectUploadGetReadyFiles)
    );

    public isExpanded = true;
    public uploadStates = EUploadState;

    public setActive(file: IUploadedFile) {
        this.store$.dispatch(uploadActions.setActiveFile({ fileId: file.tmp_id }));
        this.store$.dispatch(documentActions.cancelEditFile());
    }

    public uploadFiles() {
        this.store$.dispatch(uploadActions.startUploadingReadyFiles());
    }

    public removeFile(event: Event, file: IUploadedFile) {
        event.stopPropagation();
        this.store$.dispatch(uploadActions.removeFileFromUploadList({ values: file }));
    }
}
